/**
 * sRGB hex для MapLibre paint (без CSS `var()`).
 * Историческое значение — render-fallback для линий/полигонов БЕЗ явного цвета (старые слои).
 * НЕ менять: смена перекрашивает уже существующие данные. Для НОВЫХ фич см. [[EDITOR_DRAW_DEFAULT_HEX]].
 */
export const EDITOR_PRIMARY_LIGHT_MAP_HEX = '#9ae600' as const;

/**
 * Дефолтный цвет НОВЫХ фич/слоёв (вшивается в `paint` при создании) и цвет edit-режима Terra Draw.
 * Индиго (Tailwind indigo-500). Существующие данные не затрагивает — только то, что создаётся заново.
 */
export const EDITOR_DRAW_DEFAULT_HEX = '#6366f1' as const;
